export default "__VITE_ASSET__BYeSky80__"